import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App crash captured by ErrorBoundary:", error, info);
  }

  handleReload = () => {
    // hard reload to bypass any stale cache
    window.location.reload();
  };

  handleReset = () => {
    // clear any locally stored data that could be causing a crash, then reload
    try {
      window.localStorage && window.localStorage.clear();
    } catch (e) {
      console.warn("Impossible de vider le stockage local:", e?.message || e);
    }
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const msg = (this.state.error && (this.state.error.message || String(this.state.error))) || "Erreur inconnue";
      return (
        <div
          style={{
            minHeight: "100vh",
            background: "#0c0c0c",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "24px",
            fontFamily: "'Poppins', sans-serif",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: 460 }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>
              <span style={{ color: "#fff" }}>M.</span>
              <span style={{ color: "#ec1a79" }}>Plaisir</span>
            </div>
            <h1 style={{ fontSize: 22, margin: "8px 0" }}>Oups, un souci d'affichage</h1>
            <p style={{ color: "rgba(255,255,255,0.65)", marginBottom: 16 }}>
              Essayez « Réinitialiser » ci-dessous. Si le problème persiste, videz le
              cache du navigateur (Ctrl+Shift+R / Cmd+Shift+R).
            </p>
            <div
              style={{
                background: "rgba(255,255,255,0.06)",
                border: "1px solid rgba(255,255,255,0.12)",
                borderRadius: 10,
                padding: "10px 12px",
                fontSize: 12,
                color: "#f4c430",
                marginBottom: 20,
                wordBreak: "break-word",
              }}
            >
              Détail : {msg}
            </div>
            <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
              <button
                onClick={this.handleReset}
                style={{
                  background: "#ec1a79",
                  color: "#fff",
                  border: "none",
                  borderRadius: 999,
                  padding: "12px 28px",
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Réinitialiser
              </button>
              <button
                onClick={this.handleReload}
                style={{
                  background: "transparent",
                  color: "#fff",
                  border: "2px solid rgba(255,255,255,0.3)",
                  borderRadius: 999,
                  padding: "12px 28px",
                  fontSize: 16,
                  fontWeight: 700,
                  cursor: "pointer",
                }}
              >
                Recharger
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
